<script>
import formatTextUpperCasefirst from '@utils/format-text-upper-casefirst'
import DialogSession from '@components/Dialog/Session.vue'
import { eventTimeRange, eventIsStart, eventIsEnd, eventIsNearStart, eventOnlineStatusItem } from '@utils/zerone-event'
import { eventSessionButtonStatusItem } from '@utils/zerone-event-status'
import { FAKE_EVENT_ITEM, FAKE_SESSION_ITEM } from '@src/config/fake-evnet'
import formatDate from '@utils/format-date'

export default {
  components: {
    DialogSession,
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      },
    },
    eventItem: {
      type: Object,
      default: () => {
        return FAKE_EVENT_ITEM
      },
    },
    type: {
      type: String,
      default: 'event',
      validator(value) {
        return ['event', 'apply', 'member', 'finish'].includes(value)
      },
    },
    isSelect: {
      type: Array,
      default: () => {
        return []
      },
    },
    pageType: {
      type: String,
      default: '',
    },
    sessionItem: {
      type: Object,
      default: () => {
        return FAKE_SESSION_ITEM
      },
    },
    sessionRepeatUuids: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      isDialogSessionVisible: false,
      isDialogLoginVisible: false,
      dialogSessionItem: {},
      mouseIndex: '',
    }
  },
  computed: {
    sessionUuids: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    sessionList() {
      switch (this.type) {
        case 'apply':
          return this.sessionItem.sessions.filter((item) => {
            return !item.isEvent && item.canRegistration
          })
        default:
          return this.sessionItem.sessions.filter((item) => {
            return !item.isEvent
          })
      }
    },
  },
  methods: {
    formatTextUpperCasefirst,
    timeRange(item) {
      return eventTimeRange({ ...item })
    },
    openDialogSession(item) {
      this.isDialogSessionVisible = true
      this.dialogSessionItem = {
        date: this.sessionItem.date,
        eventType: this.eventItem.type,
        categoryTitle: this.eventItem.categoryTitle,
        ...item,
      }
    },
    onApply(uuid) {
      this.$emit('apply', {
        sessionUuids: [uuid],
      })
    },
    sessionIsNearStart(date, time) {
      return eventIsNearStart(`${date} ${time}`)
    },
    sessionIsStart(date, time) {
      return eventIsStart(`${date} ${time}`)
    },
    sessionIsEnd(date, time) {
      return eventIsEnd(`${date} ${time}`)
    },
    sessionButtonStatusItem(item) {
      return eventSessionButtonStatusItem({
        ...this.eventItem,
        inProgress: eventIsStart(`${this.sessionItem.date} ${item.startTime}`) && !eventIsEnd(`${this.sessionItem.date} ${item.endTime}`),
        canApply: item.canApply,
        canRegistration: item.canRegistration,
        sessionsEnd: eventIsEnd(`${this.sessionItem.date} ${item.endTime}`),
        isFull: item.isFull,
        regEndDateExpired: item.regEndDateExpired,
        isSession: 1,
        isApply: this.type === 'apply',
      })
    },
    eventOnlineStatusItem(sessionSessionItem) {
      return eventOnlineStatusItem({
        ...this.eventItem,
        ...sessionSessionItem,
        date: this.sessionItem.date,
      })
    },
    onSelectSession(uuid, date) {
      if (this.sessionUuids.includes(uuid) || this.sessionRepeatUuids.includes(uuid)) {
        // 刪除
        this.sessionUuids = [
          ...this.sessionUuids.filter((sessionUuid) => {
            return sessionUuid !== uuid
          }),
        ]
      } else {
        // 加入
        this.sessionUuids.push(uuid)
      }
    },
    goToMemberEventItemLive(sessionUuid) {
      this.$router.push({
        name: 'member-event-item-live',
        params: {
          sessionUuid,
        },
      })
    },
    goToMemberEventItem(sessionsSessionsItem) {
      this.$router.push({
        name: this.eventItem.categoryTitle === '課程' ? 'member-event-item' : 'member-activity-item',
        params: {
          eventAlias: this.eventItem.alias,
          seriesNum: this.eventItem.eventSeriesNum,
        },
      })
    },
    onClickOnlineButton(sessionsSessionsItem) {
      const mode = this.eventOnlineStatusItem(this.sessionItem).mode

      switch (mode) {
        case 'IS_COMMING':
        case 'IS_LIVE':
        case 'IS_END':
          this.goToMemberEventItemLive(sessionsSessionsItem.uuid)
          break
        case 'NOT_START':
          this.$alert(`直播開始時間 ${formatDate(sessionsSessionsItem.date + ' ' + sessionsSessionsItem.startTime)}`, '直播尚未開始', {
            confirmButtonText: '確定',
          })
          break
        case 'NOT_OPEN':
          this.$alert(`直播開放時間 ${formatDate(sessionsSessionsItem.linkOpeningTime)}`, '直播尚未開放', {
            confirmButtonText: '確定',
          })
          break
        default:
          break
      }
    },
    saveIndex(index) {
      this.mouseIndex = index
    },
    // mouseEnter: _debounce(function (index) {
    //   console.log('index :>> ', index)
    //   this.buttonDisappear = true
    // }, 200),
    mouseLeave() {
      this.mouseIndex = ''
    },
  },
}
</script>
<template>
  <div :class="[$style.eventSession, $style[`isStyle${formatTextUpperCasefirst(type)}`]]">
    <div
      v-for="(sessionSessionItem, index) in sessionList"
      :key="index"
      :class="[$style.courseSession, { isApply: type === 'apply' }, { isActive: sessionUuids.includes(sessionSessionItem.uuid) }, { isFinish: type === 'finish' || type === 'member' }]"
      @click="type === 'apply' && !sessionButtonStatusItem(sessionSessionItem).disabled ? onSelectSession(sessionSessionItem.uuid, sessionItem.date) : ''"
      @mouseenter="saveIndex(index)"
      @mouseleave="mouseLeave"
    >
      <div class="courseSession__time d-flex justify-content-between">
        <div>
          {{ timeRange(sessionSessionItem) }}
          <el-tag v-if="eventItem.type === 'online'" class="isStylePrimary isAngle d-lg-none"> LIVE </el-tag>
        </div>
        <BaseButton class="isText d-lg-none" @click.stop.prevent="openDialogSession(sessionSessionItem)"> 查看詳情 <i class="fal fa-chevron-right"></i> </BaseButton>
      </div>
      <div class="courseSession__content">
        <el-tag v-if="eventItem.type === 'online'" class="isStylePrimary isAngle d-lg-block d-none mr-3"> LIVE </el-tag>
        <el-tag v-else-if="sessionSessionItem.isFull === 2 && mouseIndex !== index" class="isStylePurple isSmall isRadius mr-2">已額滿</el-tag>
        <template v-if="sessionSessionItem.isFull === 2">
          <div class="courseSession__text" @click.stop.prevent="openDialogSession(sessionSessionItem)">{{ sessionSessionItem.title }} </div>
        </template>
        <template v-else>
          <div class="courseSession__text" @click.stop.prevent="openDialogSession(sessionSessionItem)">{{ sessionSessionItem.title }} </div>
        </template>
      </div>
      <div class="courseSession__action ml-lg-auto">
        <!-- 活動/課程 -->
        <template v-if="type === 'event'">
          <div class="row">
            <div :class="sessionButtonStatusItem(sessionSessionItem).display ? 'col-6' : 'col-12'" class="d-lg-block d-none">
              <BaseButton class="isStylePrimary isSmall isRadius isOutline2 isFull" @click.stop.prevent="openDialogSession(sessionSessionItem)"> 查看詳情 </BaseButton>
            </div>
            <div v-if="sessionButtonStatusItem(sessionSessionItem).display" class="col-lg-6 col-12">
              <template v-if="sessionIsNearStart(sessionItem.date, sessionSessionItem.startTime) && eventItem.type === 'online'">
                <BaseButton
                  :data-mode="eventOnlineStatusItem(sessionSessionItem).mode"
                  :class="eventOnlineStatusItem(sessionSessionItem).class2"
                  class="isFull isSmall isRadius isOutline isFull courseSession__action__btn"
                  :disabled="eventOnlineStatusItem(sessionSessionItem).disabled"
                  @click="onClickOnlineButton(sessionSessionItem)"
                >
                  {{ eventOnlineStatusItem(sessionSessionItem).title }}
                </BaseButton>
              </template>
              <template v-else>
                <template v-if="sessionButtonStatusItem(sessionSessionItem).mode === 'IN_PROGRESS'">
                  <BaseButton
                    :data-mode="sessionButtonStatusItem(sessionSessionItem).mode"
                    :class="sessionButtonStatusItem(sessionSessionItem).class"
                    class="isFull courseSession__action__btn"
                    :disabled="sessionButtonStatusItem(sessionSessionItem).disabled"
                    @click="goToMemberEventItem(sessionSessionItem)"
                  >
                    {{ sessionButtonStatusItem(sessionSessionItem).title }}
                  </BaseButton>
                </template>
                <template v-else>
                  <BaseButton
                    :data-mode="sessionButtonStatusItem(sessionSessionItem).mode"
                    :class="sessionButtonStatusItem(sessionSessionItem).class"
                    class="isFull courseSession__action__btn"
                    :disabled="sessionButtonStatusItem(sessionSessionItem).disabled"
                    @click="sessionButtonStatusItem(sessionSessionItem).mode === 'IN_LIVE' ? goToMemberEventItemLive(sessionSessionItem.uuid) : onApply(sessionSessionItem.uuid)"
                  >
                    {{ sessionButtonStatusItem(sessionSessionItem).title }}
                  </BaseButton>
                </template>
              </template>
            </div>
          </div>
        </template>
        <template v-if="type === 'apply'">
          <template v-if="sessionRepeatUuids.includes(sessionSessionItem.uuid)">
            <BaseButton class="isStyleGrey isSmall isRadius isFull" disabled> 重複報名 </BaseButton>
          </template>
          <template v-else>
            <BaseButton
              class="isStylePrimary isSmall isRadius isFull"
              :class="{ isOutline2: !sessionUuids.includes(sessionSessionItem.uuid) }"
              :disabled="sessionButtonStatusItem(sessionSessionItem).disabled"
              @click.stop.prevent="onSelectSession(sessionSessionItem.uuid, sessionItem.date)"
            >
              <template v-if="sessionUuids.includes(sessionSessionItem.uuid)"> 已選擇 </template>
              <template v-else>
                <template v-if="sessionButtonStatusItem(sessionSessionItem).disabled"> {{ sessionButtonStatusItem(sessionSessionItem).title }} </template>
                <template v-else>
                  <template v-if="sessionSessionItem.hasApplied"> 已報名 </template>
                  <template v-else> 選擇場次 </template>
                </template>
              </template>
            </BaseButton>
          </template>
        </template>
      </div>
    </div>
    <DialogSession :session-item="dialogSessionItem" :visible.sync="isDialogSessionVisible" />
    <BasePre>{{ sessionUuids }}</BasePre>
  </div>
</template>
<style lang="scss" module>
.eventSession {
  &.isStyleApply {
    cursor: pointer;
    :global {
      .courseSession {
        &__action {
          width: 160px;

          @include max-md {
            width: 100%;
          }
        }
      }
    }
  }

  /* &:global {
      &.isFinish {
        padding-right: 3rem;
        padding-left: 3rem;

        @include max-md {
          padding-right: 1rem;
          padding-left: 1rem;
        }
      }
    } */
}

.courseSession {
  display: flex;
  align-items: center;
  padding: 3rem 1.875rem;
  margin-bottom: 1.5rem;
  font-size: 1.25rem;
  background-color: #fff;
  border: transparent 1px solid;

  &:hover {
    :global {
      .courseSession__text {
        color: $color-primary;
      }
    }
  }

  @include max-lg {
    flex-direction: column;
    padding: 2rem 1rem;
    text-align: left;
    align-items: flex-start;
  }

  &:global {
    &.disabled {
      .courseSession__text {
        color: $color-gray-5;
      }

      .courseSession__time {
        color: $color-gray-5;
      }
    }

    &.isApply {
    }

    &.isFinish {
      border-bottom: $color-gray-3 1px solid;
    }

    &.isActive {
      border: $color-primary 1px solid;
      .courseSession {
        &__text {
          color: $color-primary;
        }
      }
    }
  }

  :global {
    .courseSession {
      &__time {
        min-width: 180px;
        @include max-lg {
          color: $color-gray-6;
          width: 100%;
        }
        @include max-md {
          font-size: 0.875rem;
        }
      }

      &__text {
        margin-right: 2rem;
        // font-weight: 500;
        cursor: pointer;
        transition: all 0.3s;

        @include max-lg {
          margin-right: 0;
        }
        @include max-md {
          font-size: 1rem;
        }
      }

      &__content {
        display: flex;
        align-items: center;

        @include max-lg {
          flex-direction: column;
          padding: 10px 0;
        }
      }

      &__action {
        flex-shrink: 0;
        width: 320px;

        @include max-lg {
          width: 100%;
          margin-top: 1rem;
        }
        &__btn {
          padding: 1.1rem 10px;
        }
      }
    }

    // .isStylePrimary {
    //   min-width: 128px;
    //   padding-top: 1rem;
    //   padding-bottom: 1rem;
    //   font-size: 1rem;
    // }
  }
}
</style>
